export const environment = {
  production: true,
  authCookieName: 'zitadel_access_token',
  API_ROOT: 'https://api.accounts.flyevo.com/api/',
  sentryEnvName: 'prod-frontend',
  sentryDSN: 'https://d60801552f2646fa0942edbdd299a198@sentryv2.zitemedia.com/19',
  zitadelUrl: 'https://sso.flyevo.com',
  zitadelUrlEndSession: 'https://accounts.flyevo.com/login',
  zitadelClientId: '349258919157238276',
  zitadelRedirectUri: 'https://accounts.flyevo.com/login',
};
